import { render, staticRenderFns } from "./ServiceDetailsRight.vue?vue&type=template&id=5988a8f0&"
import script from "./ServiceDetailsRight.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports